import type { AiAutocompletePlugin } from './aiAutocompletePluginType';
import { createPlugin } from './ui/components/main';

export const aiAutocompletePlugin: AiAutocompletePlugin = () => ({
	name: 'aiAutocomplete',
	pmPlugins() {
		return [
			{
				name: 'aiAutocompletePlugin',
				plugin: createPlugin,
			},
		];
	},
});
